import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Wrench } from "lucide-react";

const faqs = [
  {
    q: "Do you serve Foley and Orange Beach?",
    a: "Yes, we're based in Gulf Shores at 6642 AL-59 Unit D-3 and serve all of Baldwin County including Foley, Orange Beach, Fairhope, Daphne, Spanish Fort, and Ono Island."
  },
  {
    q: "Are you available for emergency plumbing?",
    a: "Yes, we offer 24/7 emergency plumbing services across Baldwin County. Call (251) 504-4452 anytime day or night."
  },
  {
    q: "Are you licensed and insured?",
    a: "Yes, Onyx Professional Plumbing is fully licensed with Alabama License #MP-4174 and fully insured."
  },
  {
    q: "Who owns Onyx Professional Plumbing?",
    a: "Onyx Professional Plumbing is led by owner Fischer McKenzie, an experienced licensed plumber dedicated to quality workmanship."
  },
  {
    q: "What areas do you serve?",
    a: "We're based in Gulf Shores and serve Foley, Orange Beach, Fairhope, Daphne, Spanish Fort, Ono Island, and all of Baldwin County, Alabama."
  },
];

export const HomeFAQ = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section className="py-24 bg-muted/20" id="faq">
      <div className="container mx-auto px-4" ref={ref}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          className="text-center mb-16"
        >
          <span className="text-primary font-semibold tracking-wider uppercase text-sm">
            FAQ
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mt-4">
            Common Questions
          </h2>
        </motion.div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: index * 0.08 }}
              className="bg-card border border-border rounded-xl p-6"
            >
              <h3 className="font-semibold text-foreground mb-3 flex items-start gap-3">
                <Wrench className="h-5 w-5 text-primary mt-0.5 shrink-0" />
                {faq.q}
              </h3>
              <p className="text-muted-foreground pl-8">{faq.a}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
